<template>
  <b-modal
    no-close-on-backdrop
    id="change_password"
    title="ALTERAR SENHA"
    hide-footer
    @show="evOnShow"
    @shown="evOnShown"
    @hide="evOnHide"
  >
    <form @submit.prevent="evOnSubmit">
      <div class="row">
        <div class="col-md-12 pb-0 pt-0">
          <WarningMessage
            class="text-thirteen"
            message="A senha deve conter pelo menos um caractere maísculo, um minúsculo e um especial."
          />
          <LabelRequiredField label="Senha atual" />
          <b-input-password ref="autofocus" v-model="current_password" />
        </div>
        <div class="col-md-12 py-0 mt-2">
          <LabelRequiredField label="Nova senha" />
          <b-input-password v-model="new_password" />
        </div>
        <div class="col-md-12 py-0 mt-2">
          <LabelRequiredField label="Confirme a nova senha" />
          <b-input-password v-model="new_password_confirmation" />
        </div>
        <div class="col-md-12 pb-0">
          <ErrorsMessages :errors="errors" />
          <WarningRequiredFields v-if="permission('edit', 'user')" />
        </div>
        <div class="col-md-12 pb-0 pt-0">
          <v-btn
            @click="$bvModal.hide('change_password')"
            class="btn-cancel"
            :disabled="loading"
            >CANCELAR
          </v-btn>
          <v-btn
            :disabled="loading"
            type="submit"
            block
            class="btn-save float-right"
          >
            <i class="fas fa-save mr-2 text-twenty"></i>
            {{ loading ? "Carregando" : "SALVAR" }}
          </v-btn>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../Components/ErrorsMessages";
import WarningMessage from "../Components/WarningMessage";
import WarningRequiredFields from "../Components/WarningRequiredFields";
import LabelRequiredField from "../Components/LabelRequiredField";
import permission from "../../lib/permission";
import toast from "../../lib/ToastNotification";
import api from "../../services/api";
import BInputPassword from "../Components/BInputPassword.vue";

export default {
  name: "ChangePassword",
  components: {
    ErrorsMessages,
    WarningMessage,
    WarningRequiredFields,
    LabelRequiredField,
    BInputPassword,
  },
  data() {
    return {
      errors: [],
      loading: false,

      current_password: "",
      new_password: "",
      new_password_confirmation: "",
    };
  },
  methods: {
    permission,

    async evOnShow() {
      this.loading = false;
      this.errors = [];
      this.current_password = "";
      this.new_password = "";
      this.new_password_confirmation = "";
    },

    async evOnShown() {
      this.$refs.autofocus.focus();
    },

    async evOnHide() {},

    async evOnSubmit() {
      try {
        this.loading = true;

        const data = {
          current_password: this.current_password,
          new_password: this.new_password,
          new_password_confirmation: this.new_password_confirmation,
        };

        const response = await api.patch(
          "/rest-home/user/update/password",
          data
        );

        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.$bvModal.hide("change_password");
          toast(message, "success");
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style></style>
